import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.212 19.74c.3 0 .552-.036.756-.108.204-.072.366-.168.486-.288.124-.12.212-.26.264-.42.056-.16.084-.33.084-.51 0-.188-.03-.356-.09-.504a.925.925 0 00-.282-.384 1.291 1.291 0 00-.498-.246 2.723 2.723 0 00-.726-.084H15.58v2.544h1.632zm-1.632-6.168v2.508h1.284c.552 0 .968-.1 1.248-.3.284-.2.426-.518.426-.954 0-.452-.128-.774-.384-.966-.256-.192-.656-.288-1.2-.288H15.58zm1.374-1.248c.568 0 1.054.054 1.458.162.404.108.734.262.99.462.26.2.45.442.57.726.12.284.18.604.18.96 0 .204-.03.4-.09.588-.06.184-.154.358-.282.522-.124.16-.284.306-.48.438a2.842 2.842 0 01-.69.336c1.192.268 1.788.912 1.788 1.932 0 .368-.07.708-.21 1.02-.14.312-.344.582-.612.81-.268.224-.598.4-.99.528s-.84.192-1.344.192h-3.276v-8.676h2.988z",
    fill: "currentColor"
  })));
}

export { SvgBold as ReactComponent };
